import React from "react";
import murray from '../images/murray.png';

const Extra = () => {
    return (
        <div>
            <h2>Murray</h2>
            <img src={murray} className="App-logo" alt="cat" />
        </div>
    );
};

export default Extra;